<template>
  <div>
    <tci-service-head :title="$t('service.service4.title')" :subtitle="$t('service.service4.subtitle')" :content="$t('service.service4.content')" :imgUrl='$i18n.locale=="zh"?require("../assets/service/s4-1.jpg"):require("../assets/service/s4-1-ja.jpg")'>
    </tci-service-head> 
    <tci-contact-footer color="white"></tci-contact-footer>
  </div>
</template>

<script>
import TciContactFooter from "@/components/TciContactFooter.vue";
import TciServiceHead from "@/components/TciServiceHead.vue";

export default {
  name: "CompanyService4",
  components: {
    "tci-contact-footer": TciContactFooter,
    "tci-service-head": TciServiceHead
  }
};
</script>
